export default "__VITE_ASSET__d37ef6e7__"